// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file catpocs/v1/deployments.proto (package catpocs.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file catpocs/v1/deployments.proto.
 */
export const file_catpocs_v1_deployments: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * ImageTag represents a container image tag with metadata
 *
 * @generated from message catpocs.v1.ImageTag
 */
export type ImageTag = Message<"catpocs.v1.ImageTag"> & {
  /**
   * @generated from field: string tag = 1;
   */
  tag: string;

  /**
   * @generated from field: string digest = 2;
   */
  digest: string;

  /**
   * @generated from field: google.protobuf.Timestamp first_seen_at = 3;
   */
  firstSeenAt?: Timestamp;

  /**
   * @generated from field: int64 size_bytes = 4;
   */
  sizeBytes: bigint;

  /**
   * @generated from field: map<string, string> labels = 5;
   */
  labels: { [key: string]: string };

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message catpocs.v1.ImageTag.
 * Use `create(ImageTagSchema)` to create a new message.
 */
export const ImageTagSchema: GenMessage<ImageTag> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_deployments, 0);

/**
 * ImageDeployment represents a deployment record
 *
 * @generated from message catpocs.v1.ImageDeployment
 */
export type ImageDeployment = Message<"catpocs.v1.ImageDeployment"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string application_id = 2;
   */
  applicationId: string;

  /**
   * @generated from field: string source_image = 3;
   */
  sourceImage: string;

  /**
   * @generated from field: string ecr_image = 4;
   */
  ecrImage: string;

  /**
   * @generated from field: string image_digest = 5;
   */
  imageDigest: string;

  /**
   * @generated from field: string status = 6;
   */
  status: string;

  /**
   * @generated from field: string status_message = 7;
   */
  statusMessage: string;

  /**
   * @generated from field: string deployed_by = 8;
   */
  deployedBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp deployed_at = 9;
   */
  deployedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp completed_at = 10;
   */
  completedAt?: Timestamp;
};

/**
 * Describes the message catpocs.v1.ImageDeployment.
 * Use `create(ImageDeploymentSchema)` to create a new message.
 */
export const ImageDeploymentSchema: GenMessage<ImageDeployment> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_deployments, 1);

/**
 * ListImageTagsRequest requests available tags for an application
 *
 * @generated from message catpocs.v1.ListImageTagsRequest
 */
export type ListImageTagsRequest = Message<"catpocs.v1.ListImageTagsRequest"> & {
  /**
   * @generated from field: string application_id = 1;
   */
  applicationId: string;
};

/**
 * Describes the message catpocs.v1.ListImageTagsRequest.
 * Use `create(ListImageTagsRequestSchema)` to create a new message.
 */
export const ListImageTagsRequestSchema: GenMessage<ListImageTagsRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_deployments, 2);

/**
 * ListImageTagsResponse contains available image tags
 *
 * @generated from message catpocs.v1.ListImageTagsResponse
 */
export type ListImageTagsResponse = Message<"catpocs.v1.ListImageTagsResponse"> & {
  /**
   * @generated from field: string repository = 1;
   */
  repository: string;

  /**
   * @generated from field: repeated catpocs.v1.ImageTag tags = 2;
   */
  tags: ImageTag[];
};

/**
 * Describes the message catpocs.v1.ListImageTagsResponse.
 * Use `create(ListImageTagsResponseSchema)` to create a new message.
 */
export const ListImageTagsResponseSchema: GenMessage<ListImageTagsResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_deployments, 3);

/**
 * GetImageDeploymentsRequest requests deployment history
 *
 * @generated from message catpocs.v1.GetImageDeploymentsRequest
 */
export type GetImageDeploymentsRequest = Message<"catpocs.v1.GetImageDeploymentsRequest"> & {
  /**
   * @generated from field: string application_id = 1;
   */
  applicationId: string;

  /**
   * Maximum number of deployments to return (default: 50)
   *
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * Describes the message catpocs.v1.GetImageDeploymentsRequest.
 * Use `create(GetImageDeploymentsRequestSchema)` to create a new message.
 */
export const GetImageDeploymentsRequestSchema: GenMessage<GetImageDeploymentsRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_deployments, 4);

/**
 * GetImageDeploymentsResponse contains deployment history
 *
 * @generated from message catpocs.v1.GetImageDeploymentsResponse
 */
export type GetImageDeploymentsResponse = Message<"catpocs.v1.GetImageDeploymentsResponse"> & {
  /**
   * @generated from field: repeated catpocs.v1.ImageDeployment deployments = 1;
   */
  deployments: ImageDeployment[];
};

/**
 * Describes the message catpocs.v1.GetImageDeploymentsResponse.
 * Use `create(GetImageDeploymentsResponseSchema)` to create a new message.
 */
export const GetImageDeploymentsResponseSchema: GenMessage<GetImageDeploymentsResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_deployments, 5);

/**
 * DeployImageTagRequest requests deployment of a specific tag
 *
 * @generated from message catpocs.v1.DeployImageTagRequest
 */
export type DeployImageTagRequest = Message<"catpocs.v1.DeployImageTagRequest"> & {
  /**
   * @generated from field: string application_id = 1;
   */
  applicationId: string;

  /**
   * @generated from field: string image_tag = 2;
   */
  imageTag: string;
};

/**
 * Describes the message catpocs.v1.DeployImageTagRequest.
 * Use `create(DeployImageTagRequestSchema)` to create a new message.
 */
export const DeployImageTagRequestSchema: GenMessage<DeployImageTagRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_deployments, 6);

/**
 * DeployImageTagResponse contains the created deployment
 *
 * @generated from message catpocs.v1.DeployImageTagResponse
 */
export type DeployImageTagResponse = Message<"catpocs.v1.DeployImageTagResponse"> & {
  /**
   * @generated from field: catpocs.v1.ImageDeployment deployment = 1;
   */
  deployment?: ImageDeployment;
};

/**
 * Describes the message catpocs.v1.DeployImageTagResponse.
 * Use `create(DeployImageTagResponseSchema)` to create a new message.
 */
export const DeployImageTagResponseSchema: GenMessage<DeployImageTagResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_deployments, 7);

/**
 * GetDeploymentStatusRequest requests the status of a deployment
 *
 * @generated from message catpocs.v1.GetDeploymentStatusRequest
 */
export type GetDeploymentStatusRequest = Message<"catpocs.v1.GetDeploymentStatusRequest"> & {
  /**
   * @generated from field: string deployment_id = 1;
   */
  deploymentId: string;
};

/**
 * Describes the message catpocs.v1.GetDeploymentStatusRequest.
 * Use `create(GetDeploymentStatusRequestSchema)` to create a new message.
 */
export const GetDeploymentStatusRequestSchema: GenMessage<GetDeploymentStatusRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_deployments, 8);

/**
 * GetDeploymentStatusResponse contains deployment status
 *
 * @generated from message catpocs.v1.GetDeploymentStatusResponse
 */
export type GetDeploymentStatusResponse = Message<"catpocs.v1.GetDeploymentStatusResponse"> & {
  /**
   * @generated from field: catpocs.v1.ImageDeployment deployment = 1;
   */
  deployment?: ImageDeployment;
};

/**
 * Describes the message catpocs.v1.GetDeploymentStatusResponse.
 * Use `create(GetDeploymentStatusResponseSchema)` to create a new message.
 */
export const GetDeploymentStatusResponseSchema: GenMessage<GetDeploymentStatusResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_deployments, 9);

/**
 * @generated from message catpocs.v1.ConfigureTagTrackingRequest
 */
export type ConfigureTagTrackingRequest = Message<"catpocs.v1.ConfigureTagTrackingRequest"> & {
  /**
   * @generated from field: string application_id = 1;
   */
  applicationId: string;

  /**
   * @generated from field: string tag = 2;
   */
  tag: string;

  /**
   * @generated from field: bool enabled = 3;
   */
  enabled: boolean;

  /**
   * @generated from field: catpocs.v1.TagTrackingMode mode = 4;
   */
  mode: TagTrackingMode;

  /**
   * Optional Helm path for digest pinning in auto-deploy mode
   *
   * @generated from field: string image_digest_path = 5;
   */
  imageDigestPath: string;
};

/**
 * Describes the message catpocs.v1.ConfigureTagTrackingRequest.
 * Use `create(ConfigureTagTrackingRequestSchema)` to create a new message.
 */
export const ConfigureTagTrackingRequestSchema: GenMessage<ConfigureTagTrackingRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_deployments, 10);

/**
 * @generated from message catpocs.v1.ConfigureTagTrackingResponse
 */
export type ConfigureTagTrackingResponse = Message<"catpocs.v1.ConfigureTagTrackingResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message catpocs.v1.ConfigureTagTrackingResponse.
 * Use `create(ConfigureTagTrackingResponseSchema)` to create a new message.
 */
export const ConfigureTagTrackingResponseSchema: GenMessage<ConfigureTagTrackingResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_deployments, 11);

/**
 * @generated from enum catpocs.v1.TagTrackingMode
 */
export enum TagTrackingMode {
  /**
   * @generated from enum value: TAG_TRACKING_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TAG_TRACKING_MODE_NOTIFY_ONLY = 1;
   */
  NOTIFY_ONLY = 1,

  /**
   * @generated from enum value: TAG_TRACKING_MODE_AUTO_DEPLOY = 2;
   */
  AUTO_DEPLOY = 2,
}

/**
 * Describes the enum catpocs.v1.TagTrackingMode.
 */
export const TagTrackingModeSchema: GenEnum<TagTrackingMode> = /*@__PURE__*/
  enumDesc(file_catpocs_v1_deployments, 0);

/**
 * DeploymentService manages container image deployments
 *
 * @generated from service catpocs.v1.DeploymentService
 */
export const DeploymentService: GenService<{
  /**
   * ListImageTags lists available image tags from ECR for an application
   *
   * @generated from rpc catpocs.v1.DeploymentService.ListImageTags
   */
  listImageTags: {
    methodKind: "unary";
    input: typeof ListImageTagsRequestSchema;
    output: typeof ListImageTagsResponseSchema;
  },
  /**
   * GetImageDeployments gets deployment history for an application
   *
   * @generated from rpc catpocs.v1.DeploymentService.GetImageDeployments
   */
  getImageDeployments: {
    methodKind: "unary";
    input: typeof GetImageDeploymentsRequestSchema;
    output: typeof GetImageDeploymentsResponseSchema;
  },
  /**
   * DeployImageTag deploys a specific image tag
   *
   * @generated from rpc catpocs.v1.DeploymentService.DeployImageTag
   */
  deployImageTag: {
    methodKind: "unary";
    input: typeof DeployImageTagRequestSchema;
    output: typeof DeployImageTagResponseSchema;
  },
  /**
   * GetDeploymentStatus gets the status of a deployment
   *
   * @generated from rpc catpocs.v1.DeploymentService.GetDeploymentStatus
   */
  getDeploymentStatus: {
    methodKind: "unary";
    input: typeof GetDeploymentStatusRequestSchema;
    output: typeof GetDeploymentStatusResponseSchema;
  },
  /**
   * ConfigureTagTracking configures watched tag behavior for an application
   *
   * @generated from rpc catpocs.v1.DeploymentService.ConfigureTagTracking
   */
  configureTagTracking: {
    methodKind: "unary";
    input: typeof ConfigureTagTrackingRequestSchema;
    output: typeof ConfigureTagTrackingResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_catpocs_v1_deployments, 0);

